<template>
  <div>
    <b-container>
      <h2 style="margin-bottom: -30px; margin-top: 15px">
        {{ $t("landing_eightPillars_title") }}
      </h2>
      <b-row>
        <p class="description">
          {{ $t("landing_eightPillars_description") }}
        </p>
        <div
          v-for="(pillar, key) in pillars"
          :id="pillar"
          :key="key"
          class="pillar"
        >
          <div class="acronym">
            {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
          </div>
          <b-row>
            <b-col style="margin: 0 20px 0 40px" lg="4" md="4">
              <div :class="stylePillarIcon(key)" class="pillar-icon">
                <img :class="pillar"
                  :src="'./static/icons/Home/' + pillar + '_icon.svg'"
                />
              </div>
                <h1>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h1>

            </b-col>
            <b-col>
              <p>
                {{ $t("label_indicator_pillar_" + pillar + "_description") }}
              </p>
              <h4>{{ $t("landing_eightPillars_subPillars") }}</h4>
              <div
                v-html="$t('label_indicator_pillar_' + pillar + '_subPillars')"
              />
            </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
    <!--End pillars-->
    <b-modal
      id="termsOfUse"
      v-model="showTerms"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      class="terms-modal"
    >
      <div v-html="$t('terms_of_use')" />
      <p>
        <label class="custom-control custom-checkbox">
          <input
            v-model="termsConditionsAccepted"
            type="checkbox"
            :true-value="true"
            :false-value="false"
          />
          <span class="custom-control-description">{{
            $t("acceptTerms_confirmation")
          }}</span>
        </label>
      </p>
      <div slot="modal-footer">
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="setTermsAccepted()"
        >
          <!--          :disabled="!getUserAccount.termsConditionsAccepted"-->
          {{ $t("acceptTerms_button") }}
        </b-btn>
        <b-btn size="sm" class="float-right" variant="link" @click="logout()">
          {{ $t("rejectTerms_link") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { createHelpers } from "vuex-map-fields";
import BreadcrumbHeader from "./template/_template-breadcrumb-header";
import store from "@/store";

const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});

export default {
  name: "Home",
  components: { BreadcrumbHeader },
  data: function () {
    return {
      showTerms: false,
      terms: false,
      pillars: ["OP", "PP", "RSH", "PDP", "R", "PH", "WLBS", "COM"],
      pillars2: [
        {
          title: "Organization Profile",
          text: "Organization profile and productivity",
          initials: "OP",
          icon: "op_icon",
        },
        {
          title: "Personnel profile",
          text: "Staff members information with basic indicators of gender equality",
          initials: "PP",
          icon: "pp_icon",
        },
        {
          title: "Recruitment and Selection",
          text: "Recruitment, selection and hiring",
          initials: "RSH",
          icon: "rsh_icon",
        },
        {
          title: "Professional Development",
          text: "Professional Development and Performance",
          initials: "PDP",
          icon: "pdp_icon",
        },
        {
          title: "Remuneration",
          text: "Remuneration with basic indicators of gender equality",
          initials: "R",
          icon: "r_icon",
        },
        {
          title: "Prevention of Harassment",
          text: "Prevention of harassment in the workplace",
          initials: "PH",
          icon: "ph_icon",
        },
        {
          title: "Work-Life Balance",
          text: "Work-life balance with shared social responsibility",
          initials: "WLBS",
          icon: "wlbs_icon",
        },
        {
          title: "Communication",
          text: "Inclusive communication",
          initials: "COM",
          icon: "com_icon",
        },
      ],
    };
  },
  created: async function () {
    this.showTerms = !this.getUserAccount?.termsConditionsAccepted;
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    await this.$store.dispatch("SELF_ASSESSMENT_GET");

  },
  methods: {
    logout: function () {
      this.$store
        .dispatch("USERACCOUNTS_LOGOUT")
        .then(() => this.$router.push("/"));
    },
    stylePillarIcon(index){
      if(index % 2 === 0)
        return 'primary'
      else return 'secondary'
    },
    setTermsAccepted: function () {
      var data = {
        termsConditionsAccepted: this.termsConditionsAccepted,
      };
      this.$store
        .dispatch("USERACCOUNTS_SAVE", data)
        .then(() => {
          this.showTerms = false;
        })
        .catch((err) => {
          console.log(err);
          this.logout();
        });
    },
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
    ...mapFields(["termsConditionsAccepted"]),
  },
};
</script>

<style lang="scss" scoped>

/* components/home.vue */

@import '../assets/css/variables.scss';

.banner {
  background-color: $primary-color;
}
.section {
  text-align: center;
  margin-bottom: 2.5rem;
  h2 {
    font-size: 2rem;
    text-transform: uppercase;
    margin-top: 2.5rem;
  }
  .title2 {
    border-top: 3px solid #808184;
    min-height: 3.5rem;
  }
}
.assessment {
  .assessment-tool {
    background-color: #e7e7ec;
    border-radius: 20px;
    min-height: 300px;
    padding-bottom: 10px;
    margin-left: 10px;
    margin-right: 10px;
    .header {
      position: relative;
      background-color: $primary-color;
      border-radius: inherit;
      text-align: left;
      margin-top: 25px;
      height: 110px;
      color: #fff;
      display: flex;
      vertical-align: middle;
      justify-content: center;
      flex-direction: column;
      padding-left: 110px;
      a {
        color: inherit;
        text-decoration: none;
      }
      img {
        position: absolute;
        top: -8px;
        left: -28px;
      }
      p {
        display: inline;
        font-size: 1.3rem;
        font-family: $font-title;
        text-transform: uppercase;
      }
    }
    .body {
      h4 {
        color: $primary-color;
        font-size: 1.2rem;
        padding: 1rem;
      }
      p {
        padding: 0 1rem;
      }
    }
    &.second {
      .header {
        background-color: $accent-color;
      }
      h4 {
        color: $accent-color;
      }
    }
  }
}
.resources {
  .list-group-striped {
    text-align: left;
    .item-striped:nth-of-type(odd) {
      background: #e7e7ec;
    }
    .item-striped:nth-of-type(even) {
      background: #fff;
    }
  }
  .list-group-item {
    border: none;
  }
  .btn {
    border-radius: 13px;
    padding-bottom: 7px;
  }
}
.interest {
  a {
    margin-bottom: 30px;
    text-decoration: none;
    &:hover {
      color: inherit;
    }
  }
}/*pillar*/

.pillar-icon{
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 100%;
  width: 190px;
  height: 190px;
  &.primary{
    background-color: $primary-color;
  }
  &.secondary{
    background-color: $secondary-color;
  }
  img{
    display: block;
    margin: auto;
    padding: 25px 0 0px 0;
    &.PDP{
      margin-left: 20px;
    }
    &.PH{
      margin-left: 30px;
    }
  }
}

.title {
  text-align: center;
  background-color: #e7e7ec;
  height: 75px;
  font-size: 1.1rem;
  display: flex;
  vertical-align: middle;
  justify-content: center;
  flex-direction: column;
  text-transform: uppercase;
  border-top: 2px solid #000;
}
.description {
  text-align: center;
  margin: 30px;
}
.pillar {
  width: 100%;
  border: 2px solid #464e55;
  border-radius: 15px;
  min-height: 340px;
  display: flex;
  vertical-align: middle;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: 20px;
  margin-bottom: 35px;
  margin-left: 35px;
  margin-left: 45px;

  .acronym {
    height: 80px;
    width: 80px;
    background-color: #231f20;
    color: #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    font-size: 1.4rem;
    position: absolute;
    left: -53px;
  }
  img {
    height: 165px;
  }
  h2 {
    text-transform: uppercase;
    text-align: center;
    margin-top: 20px;
    margin-left: -20px;
  }
  h4 {
    font-size: 1rem;
    text-transform: uppercase;
  }
}
@media (max-width: 576px) {
  .assessment .col-sm-10 {
    margin-left: 10px;
  }
  .assessment .assessment-tool .header p {
    font-size: 1.1rem;
  }  /*pillar*/
  .pillar .acronym {
    height: 70px;
    width: 70px;
    top: -15px;
    right: -15px;
    left: unset;
    font-size: 1.3rem;
  }
};

h1{
  margin-top: 10px;
  font-size: 1.75rem;
}

</style>
